<!--
<meta http-equiv="cache-control" content="no-cache, must-revalidate, post-check=0, pre-check=0">
<meta http-equiv="expires" content="0">
<meta http-equiv="pragma" content="no-cache">
-->
<div theme class="container"  [styleObj]='brandStyleTheme'>

  <mat-toolbar color="primary">
    <mat-toolbar-row>

      <button mat-icon-button (click)="sidenav.toggle()" class="menu-button" fxHide fxShow.lt-md>
        <mat-icon>menu</mat-icon>
      </button>

      <span [ngClass]="{ 'hidden': opened ? false : true }">Disbursements Agent</span>

      <span class="example-spacer" [ngClass]="{ 'hidden': opened ? false : true }"></span>
      <div  [ngClass]="{ 'hidden': opened ? false : true }">
        {{appVerion}}
      </div>
      <span class="example-spacer" [ngClass]="{ 'hidden': opened ? false : true }"></span>
      <img src="../assets/images/ACI-Horizontal-White.png" style="height:30%" [ngClass]="{ 'hidden': opened ? false : true }">
      <span class="example-spacer" [ngClass]="{ 'hidden': opened ? false : true }"></span>

      <span>
        <h3 class="text-center env-banner">{{environmentBanner}}</h3>
      </span>
      <span class="head-menu"></span>
      <div class="row">
        <button mat-button (click)="signout()">
          <mat-icon>logout</mat-icon> Sign Out
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-sidenav-container>
    <mat-sidenav #sidenav="matSidenav" [mode]="opened === false ? 'over' : 'side'" [opened]="opened === true" >
      @if (isUserAuthenticated) {
        <mat-nav-list>
          <div style="text-align: center;">
            @if (isBrandLogoImageShown) {
              <img class="avatar mat-elevation-z8" src="{{brandLogoImage}}"/>
            }
            <h5 class="name text-responsive">{{brandName}}</h5>
            <!-- <p class="designation">Admin</p> -->
            <mat-divider></mat-divider>
          </div>
          <!-- Here we are using menu-list-item -->
          @for (item of menu; track item) {
            <app-menu-list-item [item]="item"></app-menu-list-item>
          }
        </mat-nav-list>
      }
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>





</div>

